import { useEffect, useRef, useState } from 'react';
import { getElementPreview } from '@/lib/textPreview';
import { mm } from './editorCatalog';
import { K } from './model';

// Decorations use the server sprite so the editor shows exactly what the engraving export renders.
export const DecorationArtwork = ({ object: o, prefix }) => {
  const scale = o.scale || 1, w = Math.max(4, Math.round(o.baseW * scale * K)), h = Math.max(4, Math.round(o.baseH * scale * K));
  const stroke = Math.min(12, Math.max(.1, Number((mm(o.strokeWidthMm ?? .6) * K).toFixed(2))));
  const [sprite, setSprite] = useState(null);
  const timer = useRef(null);
  useEffect(() => {
    let alive = true;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      getElementPreview({ kind: 'decoration', ornament: o.ornament, decoration_id: o.decorationId, w, h, stroke_width: stroke }).then(data => { if (alive) setSprite(data); }).catch(() => {});
    }, sprite ? 220 : 0);
    return () => { alive = false; clearTimeout(timer.current); };
  }, [o.ornament, o.decorationId, w, h, stroke]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!sprite) return <rect x={-o.baseW / 2} y={-o.baseH / 2} width={o.baseW} height={o.baseH} fill="none" stroke="currentColor" strokeOpacity=".25" strokeDasharray="4 4" />;
  const ratio = sprite.width / sprite.height, boxRatio = o.baseW / o.baseH;
  const dw = ratio >= boxRatio ? o.baseW : o.baseH * ratio, dh = ratio >= boxRatio ? o.baseW / ratio : o.baseH;
  const tint = `${prefix}tint-${o.id}`;
  return <><defs><filter id={tint} x="0" y="0" width="100%" height="100%"><feFlood floodColor="currentColor" /><feComposite in2="SourceGraphic" operator="in" /></filter></defs>
    <image href={sprite.image} x={-dw / 2} y={-dh / 2} width={dw} height={dh} preserveAspectRatio="xMidYMid meet" filter={`url(#${tint})`} data-testid={`${prefix}decoration-artwork-${o.id}`} /></>;
};
